
 



 
 import {fs} from "Config/FsConfig";
 
    import StationAirQualityData from 'Modules/Aqs/Scripts/AppServiceContract/StationAirQualityData';

    import StationCriteria from 'Modules/Aqs/Scripts/AppServiceContract/StationCriteria';

    import StationData from 'Modules/Aqs/Scripts/AppServiceContract/StationData';

    import DistrictData from 'Modules/Aqs/Scripts/AppServiceContract/DistrictData';

    import DistrictGroupData from 'Modules/Aqs/Scripts/AppServiceContract/DistrictGroupData';

    import AirQualityIndexData from 'Modules/Aqs/Scripts/AppServiceContract/AirQualityIndexData';

    import AirQualityAreaData from 'Modules/Aqs/Scripts/AppServiceContract/AirQualityAreaData';

    import AirQualityTypeData from 'Modules/Aqs/Scripts/AppServiceContract/AirQualityTypeData';

    import StationAirQualityDataForNotifications from 'Modules/Aqs/Scripts/AppServiceContract/StationAirQualityDataForNotifications';

    import ViewDailyMinMaxCriteria from 'Modules/Aqs/Scripts/AppServiceContract/ViewDailyMinMaxCriteria';

    import ViewDailyMinMaxData from 'Modules/Aqs/Scripts/AppServiceContract/ViewDailyMinMaxData';

    import SummaryCriteria from 'Modules/Aqs/Scripts/AppServiceContract/SummaryCriteria';

    import SummaryData from 'Modules/Aqs/Scripts/AppServiceContract/SummaryData';

    import AirQualityIndexItemData from 'Modules/Aqs/Scripts/AppServiceContract/AirQualityIndexItemData';

    import EmissionMapInterpolationAllData from 'Modules/Aqs/Scripts/AppServiceContract/EmissionMapInterpolationAllData';

    import ConfigMapGraphData from 'Modules/Aqs/Scripts/AppServiceContract/ConfigMapGraphData';

    import LowcostSensorsData from 'Modules/Aqs/Scripts/AppServiceContract/LowcostSensorsData';


    //module PublicAirQualityMapAppService {
    class PublicAirQualityMapAppService {

    ControllerUrl : string
    Options : JQueryAjaxSettings

    constructor(serverBaseUrl : string = null, controllerPath : string = null, ajaxOptions : JQueryAjaxSettings = null){
        this.ControllerUrl = ((serverBaseUrl == null) ? fs.Config.ServiceBaseUrl : serverBaseUrl) + ((controllerPath == null) ?  "modules/Aqs.AppService/PublicAirQualityMapAppService" : controllerPath);
        this.Options = ajaxOptions;
    }

    public Init(options : any = { serverBaseUrl :  null, controllerPath : null, ajaxOptions : null }){
        this.ControllerUrl = ((options.serverBaseUrl == null) ? fs.Config.ServiceBaseUrl : options.serverBaseUrl) + ((options.controllerPath == null) ?  "modules/Aqs.AppService/PublicAirQualityMapAppService" : options.controllerPath);
        this.Options = options.ajaxOptions;

        return this;
    }

    
    // post: api/${controller}/
    //public static RouteFind2 = () => this.ServiceUrl + `modules/Aqs.AppServiceContract/PublicAirQualityMapAppService/Find2`;
    public RouteFind2() : string {
        return this.ControllerUrl + "/"+"Find2";
    }
    public Find2(): JQuery.jqXHR<StationAirQualityData[]> {
        return $.ajax({
                url: this.RouteFind2(),
                contentType: 'application/json; charset=utf-8',
                dataType: "json",
                type: 'post',
                data: null,
                async: this.Options == null || this.Options.async == null ? true : this.Options.async
                });
    }                
    
    // post: api/${controller}/
    //public static RouteFind = () => this.ServiceUrl + `modules/Aqs.AppServiceContract/PublicAirQualityMapAppService/Find`;
    public RouteFind() : string {
        return this.ControllerUrl + "/"+"Find";
    }
    public Find(criteria: StationCriteria): JQuery.jqXHR<StationData[]> {
        return $.ajax({
                url: this.RouteFind(),
                contentType: 'application/json; charset=utf-8',
                dataType: "json",
                type: 'post',
                data: JSON.stringify(criteria),
                async: this.Options == null || this.Options.async == null ? true : this.Options.async
                });
    }                
    
    // post: api/${controller}/
    //public static RouteDistrictDropdown = () => this.ServiceUrl + `modules/Aqs.AppServiceContract/PublicAirQualityMapAppService/DistrictDropdown`;
    public RouteDistrictDropdown() : string {
        return this.ControllerUrl + "/"+"DistrictDropdown";
    }
    public DistrictDropdown(): JQuery.jqXHR<DistrictData[]> {
        return $.ajax({
                url: this.RouteDistrictDropdown(),
                contentType: 'application/json; charset=utf-8',
                dataType: "json",
                type: 'post',
                data: null,
                async: this.Options == null || this.Options.async == null ? true : this.Options.async
                });
    }                
    
    // post: api/${controller}/
    //public static RouteDistrictGroupDropdown = () => this.ServiceUrl + `modules/Aqs.AppServiceContract/PublicAirQualityMapAppService/DistrictGroupDropdown`;
    public RouteDistrictGroupDropdown() : string {
        return this.ControllerUrl + "/"+"DistrictGroupDropdown";
    }
    public DistrictGroupDropdown(): JQuery.jqXHR<DistrictGroupData[]> {
        return $.ajax({
                url: this.RouteDistrictGroupDropdown(),
                contentType: 'application/json; charset=utf-8',
                dataType: "json",
                type: 'post',
                data: null,
                async: this.Options == null || this.Options.async == null ? true : this.Options.async
                });
    }                
    
    // post: api/${controller}/
    //public static RouteAirQualityIndexList = () => this.ServiceUrl + `modules/Aqs.AppServiceContract/PublicAirQualityMapAppService/AirQualityIndexList`;
    public RouteAirQualityIndexList() : string {
        return this.ControllerUrl + "/"+"AirQualityIndexList";
    }
    public AirQualityIndexList(): JQuery.jqXHR<AirQualityIndexData[]> {
        return $.ajax({
                url: this.RouteAirQualityIndexList(),
                contentType: 'application/json; charset=utf-8',
                dataType: "json",
                type: 'post',
                data: null,
                async: this.Options == null || this.Options.async == null ? true : this.Options.async
                });
    }                
    
    // post: api/${controller}/
    //public static RouteFindAirQualityArea = () => this.ServiceUrl + `modules/Aqs.AppServiceContract/PublicAirQualityMapAppService/FindAirQualityArea`;
    public RouteFindAirQualityArea() : string {
        return this.ControllerUrl + "/"+"FindAirQualityArea";
    }
    public FindAirQualityArea(): JQuery.jqXHR<AirQualityAreaData[]> {
        return $.ajax({
                url: this.RouteFindAirQualityArea(),
                contentType: 'application/json; charset=utf-8',
                dataType: "json",
                type: 'post',
                data: null,
                async: this.Options == null || this.Options.async == null ? true : this.Options.async
                });
    }                
    
    // post: api/${controller}/
    //public static RouteFindAirQualityType = () => this.ServiceUrl + `modules/Aqs.AppServiceContract/PublicAirQualityMapAppService/FindAirQualityType`;
    public RouteFindAirQualityType() : string {
        return this.ControllerUrl + "/"+"FindAirQualityType";
    }
    public FindAirQualityType(): JQuery.jqXHR<AirQualityTypeData[]> {
        return $.ajax({
                url: this.RouteFindAirQualityType(),
                contentType: 'application/json; charset=utf-8',
                dataType: "json",
                type: 'post',
                data: null,
                async: this.Options == null || this.Options.async == null ? true : this.Options.async
                });
    }                
    
    // post: api/${controller}/
    //public static RouteFindStationAirQualityDataForNotifications = () => this.ServiceUrl + `modules/Aqs.AppServiceContract/PublicAirQualityMapAppService/FindStationAirQualityDataForNotifications`;
    public RouteFindStationAirQualityDataForNotifications() : string {
        return this.ControllerUrl + "/"+"FindStationAirQualityDataForNotifications";
    }
    public FindStationAirQualityDataForNotifications(): JQuery.jqXHR<StationAirQualityDataForNotifications[]> {
        return $.ajax({
                url: this.RouteFindStationAirQualityDataForNotifications(),
                contentType: 'application/json; charset=utf-8',
                dataType: "json",
                type: 'post',
                data: null,
                async: this.Options == null || this.Options.async == null ? true : this.Options.async
                });
    }                
    
    // post: api/${controller}/
    //public static RouteFindStation = () => this.ServiceUrl + `modules/Aqs.AppServiceContract/PublicAirQualityMapAppService/FindStation`;
    public RouteFindStation() : string {
        return this.ControllerUrl + "/"+"FindStation";
    }
    public FindStation(): JQuery.jqXHR<StationData[]> {
        return $.ajax({
                url: this.RouteFindStation(),
                contentType: 'application/json; charset=utf-8',
                dataType: "json",
                type: 'post',
                data: null,
                async: this.Options == null || this.Options.async == null ? true : this.Options.async
                });
    }                
    
    // post: api/${controller}/${encodeURIComponent(id)}
    //public static RouteFindStationById = (id: string) => this.ServiceUrl + `modules/Aqs.AppServiceContract/PublicAirQualityMapAppService/FindStationById`;
    public RouteFindStationById(id: string) : string {
        return this.ControllerUrl + "/"+"FindStationById";
    }
    public FindStationById(id: string): JQuery.jqXHR<StationData[]> {
        return $.ajax({
                url: this.RouteFindStationById(id),
                contentType: 'application/json; charset=utf-8',
                dataType: "json",
                type: 'post',
                data: JSON.stringify(id),
                async: this.Options == null || this.Options.async == null ? true : this.Options.async
                });
    }                
    
    // post: api/${controller}/
    //public static RouteFindDailyMinMax = () => this.ServiceUrl + `modules/Aqs.AppServiceContract/PublicAirQualityMapAppService/FindDailyMinMax`;
    public RouteFindDailyMinMax() : string {
        return this.ControllerUrl + "/"+"FindDailyMinMax";
    }
    public FindDailyMinMax(criteria: ViewDailyMinMaxCriteria): JQuery.jqXHR<ViewDailyMinMaxData> {
        return $.ajax({
                url: this.RouteFindDailyMinMax(),
                contentType: 'application/json; charset=utf-8',
                dataType: "json",
                type: 'post',
                data: JSON.stringify(criteria),
                async: this.Options == null || this.Options.async == null ? true : this.Options.async
                });
    }                
    
    // post: api/${controller}/
    //public static RouteFindSummary = () => this.ServiceUrl + `modules/Aqs.AppServiceContract/PublicAirQualityMapAppService/FindSummary`;
    public RouteFindSummary() : string {
        return this.ControllerUrl + "/"+"FindSummary";
    }
    public FindSummary(criteria: SummaryCriteria): JQuery.jqXHR<SummaryData> {
        return $.ajax({
                url: this.RouteFindSummary(),
                contentType: 'application/json; charset=utf-8',
                dataType: "json",
                type: 'post',
                data: JSON.stringify(criteria),
                async: this.Options == null || this.Options.async == null ? true : this.Options.async
                });
    }                
    
    // post: api/${controller}/
    //public static RouteFindAirIndexItemTable = () => this.ServiceUrl + `modules/Aqs.AppServiceContract/PublicAirQualityMapAppService/FindAirIndexItemTable`;
    public RouteFindAirIndexItemTable() : string {
        return this.ControllerUrl + "/"+"FindAirIndexItemTable";
    }
    public FindAirIndexItemTable(): JQuery.jqXHR<AirQualityIndexItemData[]> {
        return $.ajax({
                url: this.RouteFindAirIndexItemTable(),
                contentType: 'application/json; charset=utf-8',
                dataType: "json",
                type: 'post',
                data: null,
                async: this.Options == null || this.Options.async == null ? true : this.Options.async
                });
    }                
    
    // post: api/${controller}/
    //public static RouteDefaultMap = () => this.ServiceUrl + `modules/Aqs.AppServiceContract/PublicAirQualityMapAppService/DefaultMap`;
    public RouteDefaultMap() : string {
        return this.ControllerUrl + "/"+"DefaultMap";
    }
    public DefaultMap(): JQuery.jqXHR<void> {
        return $.ajax({
                url: this.RouteDefaultMap(),
                contentType: 'application/json; charset=utf-8',
                dataType: "json",
                type: 'post',
                data: null,
                async: this.Options == null || this.Options.async == null ? true : this.Options.async
                });
    }                
    
    // post: api/${controller}/
    //public static RouteFindMap = () => this.ServiceUrl + `modules/Aqs.AppServiceContract/PublicAirQualityMapAppService/FindMap`;
    public RouteFindMap() : string {
        return this.ControllerUrl + "/"+"FindMap";
    }
    public FindMap(): JQuery.jqXHR<EmissionMapInterpolationAllData> {
        return $.ajax({
                url: this.RouteFindMap(),
                contentType: 'application/json; charset=utf-8',
                dataType: "json",
                type: 'post',
                data: null,
                async: this.Options == null || this.Options.async == null ? true : this.Options.async
                });
    }                
    
    // post: api/${controller}/
    //public static RouteFindConfigMapGraph = () => this.ServiceUrl + `modules/Aqs.AppServiceContract/PublicAirQualityMapAppService/FindConfigMapGraph`;
    public RouteFindConfigMapGraph() : string {
        return this.ControllerUrl + "/"+"FindConfigMapGraph";
    }
    public FindConfigMapGraph(): JQuery.jqXHR<ConfigMapGraphData> {
        return $.ajax({
                url: this.RouteFindConfigMapGraph(),
                contentType: 'application/json; charset=utf-8',
                dataType: "json",
                type: 'post',
                data: null,
                async: this.Options == null || this.Options.async == null ? true : this.Options.async
                });
    }                
    
    // post: api/${controller}/?isForGraph=${isForGraph}
    //public static RouteFindAveragePM25OfArea = (isForGraph: boolean) => this.ServiceUrl + `modules/Aqs.AppServiceContract/PublicAirQualityMapAppService/FindAveragePM25OfArea`;
    public RouteFindAveragePM25OfArea(isForGraph: boolean) : string {
        return this.ControllerUrl + "/"+"FindAveragePM25OfArea";
    }
    public FindAveragePM25OfArea(isForGraph: boolean): JQuery.jqXHR<AirQualityAreaData[]> {
        return $.ajax({
                url: this.RouteFindAveragePM25OfArea(isForGraph),
                contentType: 'application/json; charset=utf-8',
                dataType: "json",
                type: 'post',
                data: JSON.stringify(isForGraph),
                async: this.Options == null || this.Options.async == null ? true : this.Options.async
                });
    }                
    
    // post: api/${controller}/
    //public static RouteFindLowcostSensors = () => this.ServiceUrl + `modules/Aqs.AppServiceContract/PublicAirQualityMapAppService/FindLowcostSensors`;
    public RouteFindLowcostSensors() : string {
        return this.ControllerUrl + "/"+"FindLowcostSensors";
    }
    public FindLowcostSensors(): JQuery.jqXHR<LowcostSensorsData> {
        return $.ajax({
                url: this.RouteFindLowcostSensors(),
                contentType: 'application/json; charset=utf-8',
                dataType: "json",
                type: 'post',
                data: null,
                async: this.Options == null || this.Options.async == null ? true : this.Options.async
                });
    }                
    
}

export default PublicAirQualityMapAppService;



